module.exports = __webpack_public_path__ + "media/images/logo_gob_prov-55097d11be74541efc0f0f93dd2a0ffa.png";